import { useState } from "react";
import { Bug } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { ReportBugDialog } from "./ReportBugDialog";

/** Sidebar footer entry (was a floating corner button, which covered page controls). */
export function ReportBugButton() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  if (!user) return null;

  return (
    <>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton type="button" onClick={() => setOpen(true)} tooltip="Report a bug">
            <Bug className="h-4 w-4" />
            <span>Report a bug</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
      <ReportBugDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
